export default __webpack_public_path__ + "static/media/airstrapz-bpk-4.bcb1ee6e.png";